import { render } from "./Appbar.vue?vue&type=template&id=770acd0a&ts=true"
import script from "./Appbar.vue?vue&type=script&lang=ts"
export * from "./Appbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__